<div class="sk-container" [ngClass]="{ 'sk-loading': !isLoaded }">
    <loading-screen [displayed]="!isLoaded" [templateType]="'GENERIC'"></loading-screen>
    @if (isLoaded && !isResponseError && coupons.length) {
        <div class="heuristic-container">
            @for (coupon of coupons; track trackById(i, coupon); let i = $index) {
                <accordion data-crlat="accordion" [accordionTitle]="coupon.name" [isExpanded]="isExpanded" (function)="getCouponContent(coupon)">
                    <accordion-body>
                        <loading-screen [displayed]="!coupon.isEventsLoaded" [templateType]="'GENERIC'"></loading-screen>
                        @if (coupon.isEventsAvailable && coupon.isEventsLoaded) {
                            <section class="page-container page-inner-container">
                                <article class="container-content">
                                    <odds-card-header
                                        [events]="coupon.events"
                                        [sportConfig]="sport?.sportConfig"
                                        [selectedMarket]="coupon.events[0].markets[0]?.name">
                                    </odds-card-header>
                                    @for (eventEntity of coupon.events; track eventEntity) {
                                        <odds-card-component
                                            [event]="eventEntity"
                                            [sportConfig]="sport?.sportConfig"
                                            [selectedMarket]="eventEntity.markets[0]?.name"
                                            [gtmModuleTitle]="coupon.name"
                                            data-crlat="eventEntity">
                                        </odds-card-component>
                                    }
                                </article>
                            </section>
                        }
                        @if (!coupon.isEventsAvailable && coupon.isEventsLoaded) {
                            <no-events></no-events>
                        }
                    </accordion-body>
                </accordion>
            }
        </div>
    }
    @if (isLoaded && isResponseError) {
        <request-error (reloadFn)="reloadComponent()" [loadFailed]="isResponseError"> </request-error>
    }
    @if (isLoaded && !isResponseError && !coupons.length) {
        <no-events [message]="'sb.noCouponsFound'"></no-events>
    }
</div>
